/**
 * Builds columns from configuration and base columns
 * @param {Array} columnConfig - Column configuration
 * @param {object} baseColumns - Base column definitions
 * @returns {Array} - Built columns
 */
export const buildColumns = (columnConfig, baseColumns) =>
  columnConfig
    .map((col) => {
      const colToRender = baseColumns[col.mappedId] || baseColumns[col.id];
      if (colToRender) {
        return {
          ...colToRender,
          ...col,
          name: colToRender.name,
          render: colToRender.render,
        };
      }
      return null;
    })
    .filter((col) => !!col);

/**
 * Gets the column ID from the column object
 * @param {object} column - Column object
 * @param {string} column.id - The ID of the column
 * @returns {string} - Column ID
 */
export const getColumnId = ({ id }) => {
  return id;
};
